import React from 'react';
import { Reveal } from './showcase/Reveal';
import { ResponseTimeVignette } from './showcase/ResponseTimeVignette';
export function ProofPanel() {
  return <section id="proof" aria-labelledby="proof-title" className="border-b border-white/5 bg-ink-800" data-id="element-193" data-mp="9rb44zwxiakn">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-194" data-mp="3vwoic65zht45">
        <Reveal data-id="element-195" data-mp="3vysutchy80g1">
          <h2 id="proof-title" className="max-w-2xl font-display text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl" data-id="element-196" data-mp="xesvwvg718nm">
            Measured, not promised.
          </h2>
          <p className="mt-4 text-sm font-semibold uppercase tracking-[0.14em] text-white/45" data-id="element-197" data-mp="no7pwmy6x1uo">
            Home services client, same response-time system:
          </p>
        </Reveal>

        <Reveal delay={0.08} className="mt-6" data-id="element-198" data-mp="1g5twtp0vje9t">
          <ResponseTimeVignette data-id="element-199" data-mp="1g6lgq2l3znk9" />
        </Reveal>

        <Reveal delay={0.12} data-id="element-200" data-mp="1be24b8y5qyh1">
          <p className="mt-8 font-display text-xl font-semibold leading-snug text-white sm:text-2xl" data-id="element-201" data-mp="1bdscrgxgsj98">
            Different industry. Identical disease.
          </p>
        </Reveal>
      </div>
    </section>;
}